import fs from 'node:fs'
import path from 'node:path'
import { findUpwards } from '@cli-utils/files.js'

export function findPnpmWorkspacePath(cwd: string): string {
  const found = findUpwards(cwd, (dir) => {
    const workspacePath = path.join(dir, 'pnpm-workspace.yaml')
    return fs.existsSync(workspacePath) ? workspacePath : undefined
  })

  return found ?? path.join(path.resolve(cwd), 'pnpm-workspace.yaml')
}
